// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5jHR1","left":"styles_left__26HZU"};